"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const serializeHeaders = (headers) => {
    let localHeaders = {};
    for (const pair of headers.entries()) {
        localHeaders = {
            ...localHeaders,
            [pair[0]]: pair[1],
        };
    }
    return localHeaders;
};
exports.default = serializeHeaders;
